import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { useUpdateBuyOrder } from 'services/buy-process';
import { useBuyProcessForm } from '../../buy-process-form-utils';
import { RootState } from '../../../../global';
import { saveEditCompanyDetails } from '../../../admin/buy-process/buy-order-edit/buy-order-edit-redux';
import { useSelectConfiguration } from '../../../app/use-app';
import {
  onGoBackInForm,
  onGoForwardInForm,
  useFetchMunicipalities,
  useSaveBuyOrderFormState,
} from '../../use-buy-process-form';
import { useIsAdminOnBuyOrderEditForm } from '../../../../utils/buy-order/use-is-admin-on-buy-order-edit-form';
import { companyDetailsValidationSchema } from './company-details-utils';
import { CompanyDetailsFormState } from './company-details-types';

export const useCompanyDetails = () => {
  const { setRequestedStep, id } = useBuyProcessForm();

  const initialState = useSelector(
    (state: RootState) => state.buyOrderEdit[id].companyDetails,
  );

  const { municipalities } = useFetchMunicipalities();
  const { fees } = useSelectConfiguration();

  const formMethods = useForm<CompanyDetailsFormState>({
    mode: 'onBlur',
    resolver: yupResolver(companyDetailsValidationSchema),
    defaultValues: {
      ...initialState,
      municipality:
        initialState.municipality && initialState.municipality.id
          ? initialState.municipality
          : undefined,
    },
  });

  useSaveBuyOrderFormState(
    saveEditCompanyDetails,
    formMethods.getValues(),
    formMethods.trigger,
  );

  const dispatch = useDispatch();
  const isAdmin = useIsAdminOnBuyOrderEditForm();
  const [updateBuyOrder, updateBuyOrderMeta] = useUpdateBuyOrder(id);

  return {
    municipalities,
    formMethods,
    fees,
    initialState,
    isUpdating: updateBuyOrderMeta.isLoading,
    onSubmit: formMethods.handleSubmit((data) => {
      dispatch(saveEditCompanyDetails({ ...data, id }));
      updateBuyOrder();

      if (!isAdmin) {
        setRequestedStep((s) => s + 1);
      }
    }),
    onForward: (e: React.MouseEvent<HTMLButtonElement>) =>
      onGoForwardInForm(setRequestedStep, e),
    onBack: (e: React.MouseEvent<HTMLButtonElement>) =>
      onGoBackInForm(setRequestedStep, formMethods.trigger, e),
  };
};
